document.addEventListener("alpine:init", () => {
  Alpine.data("ProductForm", () => ({
    current_variant: null,
    variant_restock_dates: [],
    flags: {
      is_preorder: false,
    },
    init() {
      this.InitSelf();
      this.InitWatchers();
      this.CheckPreorder();
    },
    InitSelf() {
      let variant_restock_dates = JSON.parse(
        this.$el.dataset.variant_restock_dates
      );
      this.variant_restock_dates = variant_restock_dates;

      let current_variant = JSON.parse(this.$el.dataset.current_variant);
      current_variant.restock_date = variant_restock_dates.find(
        (item) => item.id == current_variant.id
      ).restock_date;
      this.current_variant = current_variant;
      this.CheckPreorder();
    },
    InitWatchers() {
      let am = this;
      document.addEventListener("variant:change", (e) => {
        // console.log(e);
        let current_variant = e.detail.variant;
        current_variant.restock_date = am.variant_restock_dates.find(
          (item) => item.id == current_variant.id
        ).restock_date;
        am.current_variant = current_variant;
        setTimeout(am.CheckPreorder.bind(am), 0);
      });
    },
    CheckPreorder() {
      let am = this;
      am.flags.is_preorder =
        am.current_variant.inventory_policy == "continue" &&
        this.current_variant.inventory_quantity <= 0;
      if (am.flags.is_preorder) {
        am.$el.querySelector(".btn[js-add-to-cart]").textContent = "PREORDER";
      }
    },
    GetPreorderText() {
      return `Expected to Ship on ${this.current_variant.restock_date}`;
    },
  }));
});

function removeWishlistFillRule(button) {
  const container = button.parentElement;
  const productData = {
    title: container.dataset.productTitle,
    price: container.dataset.productPrice
      ? container.dataset.productPrice / 100
      : null,
    id: container.dataset.productId,
    currency: container.dataset.productLocalizationisocode,
  };

  const payload = {
    product_title: productData.title,
    product_price: productData.price,
    product_id: productData.id,
    currency: productData.currency,
  };

  const path = button.querySelector("path");
  const computedFillRule = window
    .getComputedStyle(path)
    .getPropertyValue("fill-rule");

  if (computedFillRule === "nonzero") {
    path.style.fillRule = "evenodd";
    document.dispatchEvent(
      new CustomEvent("analytics:custom", {
        detail: {
          event: "Remove from wishlist",
          payload: payload,
        },
      })
    );
  } else {
    document.dispatchEvent(
      new CustomEvent("analytics:custom", {
        detail: {
          event: "Add to wishlist",
          payload: payload,
        },
      })
    );
  }
}

function initWishlistButtons() {
  document
    .querySelectorAll(".swym-add-to-wishlist:not([data-event-initialized])")
    .forEach((button) => {
      button.dataset.eventInitialized = "true";
      button.addEventListener("click", () => {
        removeWishlistFillRule(button);
      });
    });
}
initWishlistButtons();
